// Arqum 2026-10-04.
(() => {
  const settings = document.body.dataset;
  if (settings.ipsMotionEnabled !== 'true') return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const supportsObserver = 'IntersectionObserver' in window;
  const revealObserver = supportsObserver ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px 4% 0px' }) : null;
  const headingObserver = supportsObserver ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('is-pending');
      headingObserver.unobserve(entry.target);
    });
  }, { threshold: 0.2 }) : null;

  function initialize(root) {
    if (reducedMotion.matches || !supportsObserver) return;
    const selectors = [];
    if (settings.ipsMotionGoals === 'true') selectors.push('.ips-motion-goal');
    if (settings.ipsMotionReviews === 'true') selectors.push('.ips-motion-review');
    if (selectors.length) root.querySelectorAll(selectors.join(',')).forEach((element) => {
      if (element.dataset.ipsMotionBound) return;
      element.dataset.ipsMotionBound = 'true';
      revealObserver.observe(element);
    });
    if (settings.ipsMotionHeadings !== 'true') return;
    root.querySelectorAll('.ips-motion-heading:not([data-ips-motion-bound])').forEach((heading) => {
      const label = heading.textContent.trim();
      if (!label) return;
      heading.dataset.ipsMotionBound = 'true';
      heading.setAttribute('aria-label', label);
      heading.textContent = '';
      let index = 0;
      label.split(/(\s+)/).forEach((part) => {
        if (/^\s+$/.test(part)) {
          heading.appendChild(document.createTextNode(part));
          return;
        }
        const word = document.createElement('span');
        word.className = 'ips-motion-word';
        word.setAttribute('aria-hidden', 'true');
        Array.from(part).forEach((character) => {
          const span = document.createElement('span');
          span.className = 'ips-motion-char';
          span.textContent = character;
          span.style.setProperty('--ips-motion-char-delay', `${Math.min(index, 30) * 30}ms`);
          word.appendChild(span);
          index += 1;
        });
        heading.appendChild(word);
      });
      heading.classList.add('is-pending');
      headingObserver.observe(heading);
    });
  }

  function updateMotion() {
    if (reducedMotion.matches) {
      document.documentElement.classList.remove('ips-motion-ready');
      document.querySelectorAll('.ips-motion-heading.is-pending').forEach((heading) => heading.classList.remove('is-pending'));
      document.querySelectorAll('.ips-motion-reveal').forEach((element) => element.classList.add('is-visible'));
      return;
    }
    initialize(document);
    if (supportsObserver) document.documentElement.classList.add('ips-motion-ready');
  }
  updateMotion();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  reducedMotion.addEventListener('change', updateMotion);
})();
